// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap-actions[data-v-bd9b65b6] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.table-users[data-v-bd9b65b6] {\n  width: 100%;\n}\n[dir] tr[data-v-bd9b65b6]:nth-child(even) {\n  background-color: #f0f0f0;\n}\n.wrap-table[data-v-bd9b65b6] {\n  height: 600px;\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
